export const WELLNESS_CATEGORIES = [
  {
    superCategory: "Mind & Mood",
    superImage:
      "https://cdn.prod.website-files.com/63a1c97b43b15d4c89e1c2c4/6762c04b345f35c89c04b2ad_conditions.avif",
    categories: [
      {
        category: "Sleep",
        categoryImage:
          "https://cdn.prod.website-files.com/63a1c97b43b15dfae7e1c2c8/63a1c97b43b15db484e1c808_638561790e3424e9bbe523a9_how-ketamine-therapy-creates-lasting-transformation-thumb.avif",
        subcategories: [
          { name: "Sleep Quality", description: "Improves rest and recovery." },
          { name: "Sleep Duration", description: "Helps you sleep longer." },
          { name: "Circadian Rhythm", description: "Regulates sleep cycles." },
          { name: "Deep Sleep", description: "Enhances restorative sleep." },
          { name: "Relaxation & Calm", description: "Promotes relaxation." },
        ],
      },
      {
        category: "Stress Support",
        categoryImage:
          "https://cdn.prod.website-files.com/63a1c97b43b15dfae7e1c2c8/655e44d9fa89887249a4e1c0_Stephen%20Thumb.avif",
        subcategories: [
          {
            name: "Cortisol Regulation",
            description: "Balances stress hormones.",
          },
          {
            name: "Adaptogens",
            description: "Helps your body adapt to stress.",
          },
          { name: "Anxiety Relief", description: "Eases anxious feelings." },
          {
            name: "Mood Stabilizers",
            description: "Supports emotional balance.",
          },
          {
            name: "Relaxation Techniques",
            description: "Promotes calm and mindfulness.",
          },
        ],
      },
      {
        category: "Focus & Clarity",
        categoryImage:
          "https://cdn.prod.website-files.com/63a1c97b43b15d4c89e1c2c4/67521a91e3688bdd24d74bba_image.avif",
        subcategories: [
          {
            name: "Mental Alertness",
            description: "Boosts focus and clarity.",
          },
          { name: "Cognitive Function", description: "Supports brain health." },
          {
            name: "Memory & Recall",
            description: "Enhances memory retention.",
          },
          { name: "Focus Enhancers", description: "Improves attention span." },
          {
            name: "Brain Boosters",
            description: "Optimizes brain performance.",
          },
        ],
      },
      {
        category: "Mood Support",
        categoryImage:
          "https://cdn.prod.website-files.com/63a1c97b43b15d4c89e1c2c4/66cd284c20d5dd141c4b46a5_Rectangle%201%20(1).avif",
        subcategories: [
          {
            name: "Emotional Well-being",
            description: "Supports emotional balance.",
          },
          { name: "Stress Reduction", description: "Reduces stress impact." },
          { name: "Happiness & Joy", description: "Boosts mood naturally." },
          { name: "Calmness & Peace", description: "Promotes inner peace." },
          {
            name: "Anxiety & Depression Relief",
            description: "Supports a stable mood.",
          },
        ],
      },
    ],
  },
  {
    superCategory: "Gut & Immunity",
    superImage:
      "https://cdn.prod.website-files.com/63a1c97b43b15dfae7e1c2c8/63a1c97b43b15d57b1e1c859_638df70c53390539d96b5f88_KetamineMedicineInteractions_Thumbnail.avif",
    categories: [
      {
        category: "Gut Health",
        categoryImage:
          "https://cdn.prod.website-files.com/63a1c97b43b15dfae7e1c2c8/63a1c97b43b15d167ce1c7e3_630680db3595cc4bee564ce2_mindbloom_exploring-the-trust-let-go-be-open-tlo-mantra__730w.avif",
        subcategories: [
          { name: "Digestive Health", description: "Improves digestion." },
          {
            name: "Probiotics & Prebiotics",
            description: "Balances gut bacteria.",
          },
          { name: "Digestive Enzymes", description: "Aids food breakdown." },
          {
            name: "Bloating & Gas Relief",
            description: "Relieves discomfort.",
          },
          { name: "IBS Support", description: "Eases IBS symptoms." },
        ],
      },
      {
        category: "Immunity",
        categoryImage:
          "https://cdn.prod.website-files.com/63a1c97b43b15dfae7e1c2c8/63a1c97b43b15d0ad1e1c7c6_63069b706ddcee1cacdca0d7_mindbloom_can-mdma-help-with-anxiety-depression_730w.avif",
        subcategories: [
          { name: "Immune System Support", description: "Boosts immunity." },
          { name: "Antioxidants", description: "Protects against damage." },
          {
            name: "Cold & Flu Prevention",
            description: "Reduces illness risk.",
          },
          {
            name: "Antiviral Properties",
            description: "Defends against viruses.",
          },
          { name: "Inflammation Control", description: "Lowers inflammation." },
        ],
      },
      {
        category: "Detox",
        categoryImage:
          "https://cdn.prod.website-files.com/63a1c97b43b15dfae7e1c2c8/674658d34ab5017131d2cf56_image%202.avif",
        subcategories: [
          { name: "Liver Support", description: "Supports liver detox." },
          { name: "Cleansing", description: "Aids whole-body cleanse." },
          { name: "Toxin Removal", description: "Flushes toxins." },
          { name: "Antioxidants", description: "Combats oxidative stress." },
          {
            name: "Detoxifying Herbs",
            description: "Promotes detox pathways.",
          },
        ],
      },
    ],
  },
  {
    superCategory: "Body Support",
    superImage:
      "https://cdn.prod.website-files.com/63a1c97b43b15dfae7e1c2c8/63a1c97b43b15df822e1c7df_638df4da5d03960504c18a3d_Neuroscience_Thumbnail.avif",
    categories: [
      {
        category: "Energy",
        categoryImage:
          "https://cdn.prod.website-files.com/63a1c97b43b15dfae7e1c2c8/63a1c97b43b15d06bbe1c8c5_6093e8531e3e5cf97897e957_mindbloom-psychedelic-therapy-new-years-resolutions-goals_730w.avif",
        subcategories: [
          { name: "Fatigue Relief", description: "Reduces tiredness." },
          { name: "Endurance Boost", description: "Improves stamina." },
          { name: "Stamina", description: "Sustains physical output." },
          { name: "Energy Levels", description: "Increases daily energy." },
          { name: "Vitality", description: "Enhances overall vigor." },
        ],
      },
      {
        category: "Hormonal Balance",
        categoryImage:
          "https://cdn.prod.website-files.com/63a1c97b43b15dfae7e1c2c8/66ee4f94b0ed288a661bafea_Rectangle%2041882.avif",
        subcategories: [
          {
            name: "Menstrual Cycle Support",
            description: "Eases menstrual symptoms.",
            hiddenFor: ["men"],
          },
          {
            name: "PMS Relief",
            description: "Reduces PMS discomfort.",
            hiddenFor: ["men"],
          },
          {
            name: "Testosterone Support",
            description: "Boosts male hormones.",
            hiddenFor: ["women"],
          },
          {
            name: "Estrogen Regulation",
            description: "Balances estrogen levels.",
          },
          { name: "Thyroid Support", description: "Supports thyroid health." },
          {
            name: "Fertility Support",
            description: "Promotes reproductive health.",
            hiddenFor: ["kids"],
          },
        ],
      },
      {
        category: "Joint Support",
        categoryImage:
          "https://cdn.prod.website-files.com/63a1c97b43b15dfae7e1c2c8/63a1c97b43b15d6d34e1c89a_60b3f9015508bb7fa051b830_mindbloom-preparation_730w.avif",
        subcategories: [
          {
            name: "Cartilage Repair",
            description: "Rebuilds joint cushioning.",
          },
          {
            name: "Inflammation Reduction",
            description: "Reduces joint inflammation.",
          },
          { name: "Mobility & Flexibility", description: "Improves movement." },
          { name: "Bone Health", description: "Strengthens bones." },
          { name: "Arthritis Relief", description: "Eases joint pain." },
        ],
      },
      {
        category: "Weight Support",
        categoryImage:
          "https://cdn.prod.website-files.com/63a1c97b43b15dfae7e1c2c8/669fe2a550238f45de3377e1_Testimonial.avif",
        subcategories: [
          { name: "Appetite Control", description: "Curbs cravings." },
          { name: "Metabolism Boost", description: "Speeds up metabolism." },
          { name: "Fat Loss", description: "Aids in fat burning." },
          {
            name: "Lean Muscle Gain",
            description: "Supports muscle building.",
          },
          {
            name: "Body Composition",
            description: "Improves fat-muscle ratio.",
          },
        ],
      },
    ],
  },
  {
    superCategory: "Longevity",
    superImage:
      "https://cdn.prod.website-files.com/63a1c97b43b15dfae7e1c2c8/63a1c97b43b15d4c37e1c8ca_6303fe1c8c2256302202ccf8_mindbloom_psychedelics-vs-plant-medicines-definitions-differences_730w.avif",
    categories: [
      {
        category: "Skin & Hair",
        categoryImage:
          "https://cdn.prod.website-files.com/63a1c97b43b15dfae7e1c2c8/63a1c97b43b15d4c56e1c92d_62dae508eb790f993775a7e8_mindbloom_why-the-stigma-around-psychedelic-medicine-is-shifting_730w.avif",
        subcategories: [
          { name: "Skin Hydration", description: "Keeps skin moisturized." },
          { name: "Collagen Support", description: "Boosts skin firmness." },
          { name: "Hair Growth", description: "Promotes healthy hair." },
          { name: "Acne & Skin Clarity", description: "Clears skin." },
          { name: "Anti-aging", description: "Reduces visible aging." },
        ],
      },
      {
        category: "Cellular Health",
        categoryImage:
          "https://cdn.prod.website-files.com/63a1c97b43b15dfae7e1c2c8/63a1c97b43b15d5107e1c7fd_616a38c100d959a55615ea7e_mindbloom-differences-mdma-ketamine_730w.avif",
        subcategories: [
          { name: "Mitochondrial Function", description: "Energizes cells." },
          {
            name: "Oxidative Stress Reduction",
            description: "Protects cells.",
          },
          { name: "Autophagy Support", description: "Aids cell renewal." },
          { name: "Telomere Support", description: "Supports healthy aging." },
          {
            name: "Epigenetic Modulation",
            description: "Optimizes gene expression.",
          },
        ],
      },
      {
        category: "Cardiovascular Health",
        categoryImage:
          "https://cdn.prod.website-files.com/63a1c97b43b15dfae7e1c2c8/63a1c97b43b15d53c5e1c905_639ba7f7a189f0a8533d9a7a_K-Hole_THumb.avif",
        subcategories: [
          {
            name: "Circulation & Blood Flow",
            description: "Improves blood flow.",
          },
          {
            name: "Cholesterol & Lipid Balance",
            description: "Balances blood fats.",
          },
          { name: "Heart Health", description: "Supports heart function." },
        ],
      },
      {
        category: "Recovery & Resilience",
        categoryImage:
          "https://cdn.prod.website-files.com/63a1c97b43b15dfae7e1c2c8/63a1c97b43b15d23abe1c8fa_62dae42b31197908de1c6afd_mindbloom_what-does-holding-space-mean_730w.avif",
        subcategories: [
          { name: "Muscle Recovery", description: "Speeds up recovery." },
          { name: "Sleep Recovery", description: "Deepens sleep repair." },
          {
            name: "Stress Recovery",
            description: "Restores balance post-stress.",
          },
        ],
      },
    ],
  },
];
